<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
        <v-flex xs12 mb-3>
          <h1 class="max text-xs-center text-md-left">Registrar Transação</h1>
        </v-flex>
        <v-flex xs12>
          <v-card id="transaction-card" class="mb-3 border-radius-10">
            <v-card-text>
              <v-layout row wrap px-3>
                <v-flex xs12 lg4>

                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-layout row wrap>
                <v-flex xs12 lg12 style="display: flex; justify-items: flex-end;">
                  <v-btn dark style="flex: 1; background-color: var(--background-color);"
                    @click="step = 2"
                  >
                    Registrar
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
import LeftBarLayout from "./layouts/LeftBarLayout"
import utils from "./shared/Utils"

export default {
  name: 'CustomerScheduledNewBankTransaction',
  components: { layout: LeftBarLayout },
  data() {
    return {
    }
  },
  watch: {
  },
  computed: {
  },
  mounted() {
    this.$root.authenticationStore.redirectIfNotAuthenticated()
  },
  created() {
  },
  destroyed() {
  },
  methods: {
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
</style>





// WEBPACK FOOTER //
// src/CustomerScheduledNewBankTransaction.vue